module.exports = __webpack_public_path__ + "media/12-10.38a9e217.mp4";